import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonService } from '@core/services/common.service';
import { DataService } from '@core/services/data.service';
import { PolicyService } from '@core/services/policy.service';
import { PolicyStates } from '@shared/models/codebooks/policy-state';
import { Policy } from '@shared/models/policy';

@Component({
    selector: 'app-new-claim',
    templateUrl: './new-claim.component.html',
    styleUrls: ['./new-claim.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NewClaimComponent implements OnInit {
  public activePolicies: Policy[];
  public inactivePolicies: Policy[];

  readonly policyStates: PolicyStates;

  constructor(
    private policyService: PolicyService,
    private dataService: DataService,
    private commonService: CommonService
  ) {

    this.policyStates = this.dataService.policyStates;

    this.policyService.getActivePolicies().subscribe(policies => {
      this.activePolicies = policies;
    })

    this.policyService.getInactivePolicies().subscribe(policies => {
      this.inactivePolicies = policies;
    });
  }

  ngOnInit(): void {
  }

}
